import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Schedule, ScheduleBlock, ScheduleCreate, schedulequery } from '../../../../models/schedule';
import { ScheduleService } from '../../../../services/schedule.service';
import { ApiResult } from '../../../../models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import {
    MessageService,
    ConfirmationService,
    SelectItem,
} from "primeng/primeng";
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { DoctorsService } from 'src/app/services/doctors.service';
import { CountriesService } from 'src/app/services/countries.service';
import { SpecialityService } from 'src/app/services/speciality.service';
import { Specialty } from 'src/app/models/Speciality';
import { Router } from '@angular/router';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { Title } from "@angular/platform-browser";
import { DateUtilService, moment_duration } from '../../../../utilities/date.util.service';
import { TraceClassDecorator } from '@sentry/angular';
import { TokenService } from '../../../../utilities/token.service';
import { MessagesEgdUserQuery } from '../../../../models/Doctor';
import { ROLES } from 'src/app/constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@TraceClassDecorator()
@Component({
    selector: 'app-doctor-schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.css'
        , '../../../../../assets/css/custom-egd.css'
    ],
    encapsulation: ViewEncapsulation.None,
    providers: [MessageService, ConfirmationService],

})
export class ScheduleComponent implements OnInit {

    base_url: string = "";
    doctor_user_id: string;
    ModifyTimeDialog: Boolean = false;
    BlockTimeDialog: Boolean = false;
    CreateScheduleDialog: boolean = false;
    schedules: Schedule[] = [];
    schedule_create: ScheduleCreate;
    Queryschedule: schedulequery;
    rowGroupMetadata: any;
    block_ids: number[] = [];
    block_dates: string[] = [];
    confirmScheduleBlock: Boolean = false
    confirmationDateString = "";
    date = new Date();
    selectedDate: Date = null;
    selected_end_date: Date = null;
    fromTime: Date = null;
    toTime: Date = null;
    is_end_date: boolean = false;
    defaultDate: Date;
    param = new MessagesEgdUserQuery();
    specialties: SelectItem[] = [];
    countries: SelectItem[] = [];
    is_filter: boolean = false;
    doctor_list: SelectItem[] = [];
    current_user_guid: string = null;
    medical_profession_role: number;
    private readonly days: string[] = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thurday", "Friday", "Saturday"];
    create_api_result: ApiResult = new ApiResult(false);
    block_api_result: ApiResult = new ApiResult(false);
    table_api_result: ApiResult = new ApiResult(false);
    list_api_result: ApiResult = new ApiResult(false);
    provider_id: string = "";
    slug: string = "";

    constructor(
        private readonly router: Router,
        private readonly scheduleService: ScheduleService,
        private readonly confirmation: ConfirmationService,
        private readonly messageService: MessageService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly doctorsService: DoctorsService,
        private readonly specialtyService: SpecialityService,
        private readonly countryService: CountriesService,
        private readonly titleServices: Title,
        private readonly utilitiesService: UtilitiesService,
        private readonly dateUtil: DateUtilService,
        private readonly tokenUtil: TokenService,
        private readonly providerStateService: ProviderStateService
    ) {
        this.base_url = this.utilitiesService.getBaseUserURL(this.router.url, 2)

        

    }

    async ngOnInit() {
        this.titleServices.setTitle("Dashboard - Add/Edit Schedule");
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink:['/', this.slug, this.base_url]},
            { label: 'Schedule' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        this.date = new Date();
        this.doctor_user_id = sessionStorage.getItem('userid');
        this.medical_profession_role = this.tokenUtil.findRoleId();
        if (this.medical_profession_role == ROLES.Other_Medical_Professional_Admin) this.param.is_dietician = true;
        this.ResetSchedule(true);
        this.defaultDate = new Date();
        this.param.has_schedules = false;
        this.param.is_doctor = true;
        this.current_user_guid = this.doctor_user_id;
        this.defaultDate.setMinutes(0);
        if (this.showListForRoles()) {
            await this.GetDoctors();
            if (this.isAdmin())
                this.current_user_guid = this.doctor_list[0].value;
        }
        await this.getDataInDatatable();
    }


    showListForRoles(): boolean {
        const roles = [ROLES.SuperAdmin, ROLES.SuperAdmin_Doctor, ROLES.Other_Medical_Professional_Admin, ROLES.Support];
        return roles.includes(this.medical_profession_role);
    }

    isAdmin(): boolean {
        const roles = [ROLES.SuperAdmin, ROLES.Admin, ROLES.Other_Medical_Professional_Admin, ROLES.Support];
        return roles.includes(this.medical_profession_role);
    }

    async GetDoctors(): Promise<void> {
        this.list_api_result = new ApiResult(true);
        await this.doctorsService.findUserList(this.param)
            .toPromise()
            .then((result) => {
                this.doctor_list = [];
                if (result.success) {
                    const temp: SelectItem[] = [];
                    // temp.push({ label: "Select a doctor", value: null });
                    for (const data of result.data) {
                        temp.push(
                            {
                                label: data.first_name + " " +
                                    (data.middle_name == null ? '': data.middle_name) + " " +
                                    data.last_name + " (" +
                                    data.d_specialty_type.specialty_name + ", " +
                                    data.country.country_name + ")",
                                value: data.user_guid
                            }
                        )
                    }
                    this.doctor_list = temp;
                }
                this.list_api_result.Posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.list_api_result.ServerError = error.error;
                this.list_api_result.PromiseResult.success = false;
                this.list_api_result.Posting = false;
            });
    }

    async CallCountryAndSpecialtyFn(): Promise<void> {
        if (this.is_filter) {
            await this.FetchSpecialty();
            await this.FetchCountries();
        }
        else {
            this.param.country_id = null;
            this.param.specialty_id = null;
            await this.GetDoctors();
        }
    }

    private async FetchSpecialty(): Promise<void> {
        if (this.specialties.length == 0) {
            this.list_api_result = new ApiResult(true);
            await this.specialtyService.GetAllSpecialities(undefined,this.provider_id).toPromise()
                .then(result => {
                    if (result.success) {
                        this.specialties = [
                            {
                                label: "None",
                                value: null
                            }
                        ]
                        let temp: Specialty[] = result.data;
                        temp.forEach(specialty => {
                            this.specialties.push(
                                {
                                    label: specialty.specialty_name,
                                    value: specialty.id
                                }
                            )
                        })
                    }
                    this.list_api_result.Posting = false;
                }).catch((error: HttpErrorResponse) => {
                    this.list_api_result.ServerError = error.error;
                    this.list_api_result.PromiseResult.success = false;
                    this.list_api_result.Posting = false;
                });
        }
    }

    private async FetchCountries(): Promise<void> {
        if (this.countries.length == 0) {
            this.list_api_result = new ApiResult(true);
            await this.countryService.getCountries(this.provider_id).toPromise()
                .then(result => {
                    this.countries = [
                        {
                            label: "None",
                            value: null
                        }
                    ]
                    for (const country of result) this.countries.push(
                        {
                            label: country.country_name,
                            value: country.id
                        }
                    )
                    this.list_api_result.Posting = false;
                }).catch((error: HttpErrorResponse) => {
                    this.list_api_result.ServerError = error.error;
                    this.list_api_result.PromiseResult.success = false;
                    this.list_api_result.Posting = false;
                });
        }
    }

    async getDataInDatatable() {
        this.table_api_result = new ApiResult(true);
        this.schedule_create.user_guid = this.current_user_guid;
        let fromDate = new Date().toISOString();
        let temp = new Date();
        temp.setDate(new Date().getDate() + 20);
        let toDate = temp.toISOString();
        this.Queryschedule = {
            user_guid: this.current_user_guid,
            fromdate: fromDate,
            todate: toDate
        }
        await this.GetScheduleQuery();
        this.table_api_result.Posting = false;
    }

    ResetSchedule(fullreset: boolean) {
        if (fullreset) {
            this.schedule_create = {
                user_guid: null,
                from_date: null,
                to_date: null,
            }
        }
        else {
            this.schedule_create = {
                user_guid: this.schedule_create.user_guid,
                from_date: null,
                to_date: null,
            }
        }

    }

    SetTime(date: Date, hours: number): Date {
        if (date) return this.dateUtil.addQuantity(date, hours, moment_duration.hours)
        return date;
    }

    confirmSchedulesBlock(event: Event) {
        this.block_ids = [];
        this.block_dates = [];
        for (let i = 0; i < this.schedules.length; i++) {
            if (!this.schedules[i].status) {
                if (this.schedules[i].block) {
                    this.block_ids.push(this.schedules[i].slot_id)
                    let a: String = new Date(this.schedules[i].slot_time).toDateString();
                    let b: String = new Date(this.schedules[i].slot_time).toLocaleTimeString();
                    this.block_dates.push(a + " " + b);
                }
            }
        }
        if (this.block_dates.length > 0) {

            this.confirmationDateString = "";
            for (let i = 0; i < this.block_dates.length; i++) {
                if ((i + 1) % 3 == 1) {
                    this.confirmationDateString += "<p>" + this.block_dates[i] + "  |  ";
                }
                else if ((i + 1) % 3 == 2) {
                    this.confirmationDateString += this.block_dates[i] + "  |  ";
                }
                else if ((i + 1) % 3 == 0) {
                    this.confirmationDateString += this.block_dates[i] + "</p>";
                }
            }

            if (event.defaultPrevented) return;
            event.preventDefault();
            this.confirmation.confirm({
                key: "confirm-block-schedule",
                message:
                    "<p>Are you sure to block the following schedules ?</p>" + this.confirmationDateString
                ,
                accept: async () => {
                    await this.BlockSubmitData();
                },
                reject: () => {
                    this.BlockReject();
                },
            });
        }
        else if (this.block_dates.length == 0) {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "No Schedule  Selected",
            });
        }
    }

    async updateRowGroupMetaData() {
        this.rowGroupMetadata = {};
        for (let i = 0; i < this.schedules.length; i++) {
            let rowData = this.schedules[i];
            let representativeName = this.dateUtil.getDateResettingTime(rowData.slot_time).valueOf();
            if (i == 0) {
                this.rowGroupMetadata[representativeName] = { index: 0, size: 1 };
            }
            else {
                let previousRowData = this.schedules[i - 1];
                let previousRowGroup = this.dateUtil.getDateResettingTime(previousRowData.slot_time).valueOf();
                if (representativeName === previousRowGroup) {
                    if (this.rowGroupMetadata[representativeName] == null)
                        this.rowGroupMetadata[representativeName] = { index: i - 1, size: 2 };
                    else
                        this.rowGroupMetadata[representativeName].size++;
                }
                else
                    this.rowGroupMetadata[representativeName] = { index: i, size: 1 };
            }
        }
    }

    getDateResettingTime(date: Date): number {
        return this.dateUtil.getDateResettingTime(date).valueOf();
    }

    GetDay(date: Date): string {
        date = new Date(date);
        return this.days[date.getDay()];
    }

    Cancel() {
       
        this.ModifyTimeDialog = false;
        this.BlockTimeDialog = false;
        this.CreateScheduleDialog = false;
    }


    async BlockSubmitData() {
        this.block_api_result = new ApiResult(true);
        let data: ScheduleBlock = {
            schedule_ids: this.block_ids
        }
        await this.scheduleService.Block(this.current_user_guid, data).toPromise()
            .then(async result => {
                this.block_api_result.PromiseResult = result;
                if (this.block_api_result.PromiseResult.success) {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Schedule  Deleted  Successfully",
                    });
                    await this.getDataInDatatable();
                }
                else if (!this.block_api_result.PromiseResult.success) {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        sticky: true,
                        detail: result.error.code + " : " + result.error.message,
                    });

                }
                this.block_api_result.Posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.block_api_result.ServerError = error.error;
                this.block_api_result.PromiseResult.success = false;
                this.block_api_result.Posting = false;
            });
    }

    BlockReject() {
        this.block_ids = [];
        this.block_dates = [];
        for (let i = 0; i < this.schedules.length; i++) {
            if (!this.schedules[i].status && this.schedules[i].block) {
                this.schedules[i].block = false;
            }
        }

    }


    showDialogToAdd() {
        this.defaultDate = new Date();
        this.defaultDate.setMinutes(0);
        this.selected_end_date = null;
        this.is_end_date = false;
        this.toTime = null;
        this.fromTime = null;
        this.selectedDate = null;
        this.create_api_result.PromiseResult.error = null;
        this.CreateScheduleDialog = true;
    }

    async getSchedules() {
        await this.getDataInDatatable();
    }
    async CancelSchedulesQuery() {
        if (this.isAdmin())
            this.current_user_guid = this.doctor_list[0].value;
        else
            this.current_user_guid = this.doctor_user_id;
        await this.getDataInDatatable();
    }

    async SubmitCreateScheduleData() {
        this.create_api_result = new ApiResult(true);
        let a: Date = new Date(this.selectedDate);
        let b: Date = new Date(this.selectedDate);
        a.setSeconds(0)
        a.setMinutes(this.fromTime.getMinutes())
        a.setHours(this.fromTime.getHours())
        b.setSeconds(0)
        b.setMinutes(this.toTime.getMinutes())
        b.setHours(this.toTime.getHours())

        this.schedule_create.from_date = new Date(a).toISOString();
        this.schedule_create.to_date = new Date(b).toISOString();
        if (this.is_end_date) {
            let end_date: Date = new Date(this.selected_end_date);
            let to = end_date.valueOf();
            let from = b.valueOf();
            let diff = to - from;
            diff = Math.floor(diff / (1000 * 60 * 60 * 24))
            if (diff >= 0) {
                end_date.setSeconds(0);
                end_date.setMinutes(this.toTime.getMinutes())
                end_date.setHours(this.toTime.getHours())
                this.schedule_create.end_date = new Date(end_date).toISOString();
            }
            else {
                this.schedule_create.end_date = null;
                this.create_api_result.PromiseResult = {
                    success: false,
                    error: {
                        code: "",
                        message: "Invalid dates"
                    },
                    data: null
                }
                this.create_api_result.Posting = false;
                return;
            }
        }
        else this.schedule_create.end_date = null;
        await this.scheduleService.CreateSchedules(this.schedule_create)
            .toPromise()
            .then(async result => {
                this.create_api_result.PromiseResult = result;
                if (this.create_api_result.PromiseResult.success) {
                    this.ResetSchedule(false);
                    this.CreateScheduleDialog = false;
                    await this.getDataInDatatable();
                    this.selectedDate = null;
                    this.fromTime = null;
                    this.toTime = null;
                    this.selected_end_date = null;
                    this.is_end_date = false;
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Schedule  Submitted  Successfully",
                    });
                }
                else if (!this.create_api_result.PromiseResult.success) {
                    this.create_api_result.PromiseResult.error = result.error;
                }
                this.create_api_result.Posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.create_api_result.ServerError = error.error;
                this.create_api_result.PromiseResult.success = false;
                this.create_api_result.Posting = false;
            });

    }

    async GetScheduleQuery() {
        await this.scheduleService.GetSchedules(this.Queryschedule).toPromise()
            .then(result => {
                this.table_api_result.PromiseResult = result;
                if (this.table_api_result.PromiseResult.success) {
                    let schedules_result = result.data.slots;
                    let temp_schedules: Schedule[] = [];
                    for (let i = 0; i < schedules_result.length; i++) {
                        let temp: Schedule = {
                            sr_no: i,
                            slot_id: schedules_result[i].id,
                            slot_time: schedules_result[i].slot_time,
                            status: schedules_result[i].status,
                            date: new Date(schedules_result[i].slot_time).toDateString(),
                            block: false
                        }
                        temp_schedules.push(temp);
                    }
                    this.schedules = temp_schedules;
                }
                else if (!this.table_api_result.PromiseResult.success) {
                    this.table_api_result.PromiseResult.error = result.error;
                }
            }).catch((error: HttpErrorResponse) => {
                this.table_api_result.ServerError = error.error;
                this.table_api_result.PromiseResult.success = false;
                this.table_api_result.Posting = false;
                this.schedules = [];
            });
        await this.updateRowGroupMetaData();
    }

}
